import React from "react";
import "./AboutUs.css";
import { FaTelegram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";

const AboutUs = () => {
  return (
    <section className="about-team">
      <h2>Мы всегда на связи</h2>
      <p>
        Если у вас возникли вопросы, просто напишите нам в Telegram – мы всегда готовы помочь!
      </p>

      <div className="team-contacts">
        <a href="https://t.me/qqudyrtpashh" target="_blank" rel="noopener noreferrer" className="telegram-link">
          <FaTelegram className="telegram-icon" />
          <span>Написать в Telegram</span>
        </a>
      </div>
      <div className="team-contacts">
        <a
          href="https://wa.me/77755920999" // замените на ваш номер в формате международного кода без +
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-link"
        >
          <FaWhatsapp className="whatsapp-icon" />
          <span>Написать в WhatsApp</span>
        </a>
      </div>
    </section>
  );
};

export default AboutUs;
